import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "text-lg font-medium" }
const _hoisted_2 = {
  key: 0,
  class: "ml-1 text-red-500"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'ListRowItem',
  props: {
  title: {
    type: String,
    required: true,
  },
  flex: {
    type: Boolean,
    required: false,
    default: true,
  },
  centerLabel: {
    type: Boolean,
    required: false,
    default: true,
  },
  showDivider: {
    type: Boolean,
    required: false,
    default: false,
  },
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  capitalize: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.flex ? 'flex flex-wrap md:flex-nowrap' : '', 'w-full border-b border-gray-300'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'items-center': __props.centerLabel, 'border-r border-gray-400': __props.showDivider }, 'flex w-full md:w-1/2 lg:w-2/3 px-4 py-2'])
    }, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.capitalize ? __props.title.charAt(0).toUpperCase() + __props.title.slice(1) : __props.title), 1),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([__props.flex ? 'md:w-1/2 lg:w-1/2' : '', 'w-full px-4 md:py-2 pb-2'])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})